<template>
    <div class="row mb-3 align-items-center" v-if="product.flag_is_visible_in_normal_mode === true">

        <div class="col-5">
            <h4>
                {{ this.product.name }}
            </h4>
            <div class="product-description" v-if="!product_description_is_empty">
                {{this.product['product_description'] ?? ''}}
            </div>
        </div>

        <div class="col-2 text-end product-price">
            {{ product_price }}
        </div>

        <div class="col-5">
            <div class="input-group justify-content-end">
                <button
                    type="button"
                    v-bind:disabled="if_current_event()"
                    class="btn btn-sm btn-primary btn-decrease"
                    ref="btn-decrease"
                    @click="decreaseProductQty">
                    <i class="fas fa-minus"></i>
                </button>
                <input
                    v-bind:name="product_quantity_input_name"
                    v-bind:disabled="if_current_event()"
                    type="number"
                    ref="btn-qty"
                    class="form-control form-control-sm input-number-no-arrow text-center input-product-qty"
                    readonly
                    min="0"
                    v-model="product_quantity">
                <button
                    type="button"
                    v-bind:disabled="if_current_event()"
                    class="btn btn-sm btn-primary btn-increase"
                    ref="btn-increase"
                    @click="increaseProductQty">
                    <i class="fas fa-plus"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {empty, formatCurrency } from "../../helpers/kiosk-helpers";

export default {
    name: "RegularProduct",

    data() {
        return {
            cart_item: null,
            cart_item_data: {},
            product_description_is_empty: true,
            product_price: 0,
            product_quantity: 0,
            product_quantity_input_name: null,
            quantity_selection_interval: null,
            product_event_id: null,
        }
    },


    methods: {
        init()
        {

            this.product_description_is_empty = empty(this.product['product_description']);
            this.product_quantity_input_name = 'product-qty-' + this.product.idx;
            this.product_price = formatCurrency(this.product['prices_informations']['default_price']);

            this.product_event_id = this.event.idx;

            this.cart_item_data = {
                product_id: this.product.idx,
                store_id: this.$root.store_id,
                event_id: this.event.idx,
            }




            this.product_quantity = this.$root.cart_products_quantity[this.product.idx+"-"+this.cart_item_data.event_id] ?? 0;


            this.$root.ticketing.item[this.cart_item_data.product_id+"-"+this.cart_item_data.event_id]= {quantity: this.product_quantity,product_id: this.cart_item_data.product_id,store_id: this.cart_item_data.store_id, event_id: this.cart_item_data.event_id};

        },
        if_current_event()
        {
            if(this.$root.current_event === null || this.event.idx === this.$root.current_event.idx)
            {
                return false;
            }
            return true;
        },


        increaseProductQty()
        {
            this.product_quantity++;

            this.$root.current_event = this.$root.event_list[this.product_event_id];

            this.$root.ticketing.item[this.cart_item_data.product_id+"-"+this.cart_item_data.event_id] = {quantity: this.product_quantity,product_id: this.cart_item_data.product_id,store_id: this.cart_item_data.store_id, event_id: this.cart_item_data.event_id};
            this.$root.refreshTicketing();
        },
        decreaseProductQty()
        {
            let min = this.$refs["btn-qty"].getAttribute('min');
            let previous_quantity = this.product_quantity;

            this.product_quantity--;

            if(min !== null && this.product_quantity < min)
            {
                this.product_quantity = min;
            }

            this.$root.ticketing.item[this.cart_item_data.product_id+"-"+this.cart_item_data.event_id] = {quantity: this.product_quantity,product_id: this.cart_item_data.product_id,store_id: this.cart_item_data.product_id, event_id: this.cart_item_data.event_id};

            this.$root.refreshTicketing();
        },



        disableProductControls()
        {
            this.$refs['btn-decrease'].disabled = true;
            this.$refs['btn-increase'].disabled = true;
        },

        enableProductControls()
        {
            this.$refs['btn-decrease'].disabled = false;
            this.$refs['btn-increase'].disabled = false;
        },



    },

    mounted: function mounted() {
        this.init();
    },

    props: {
        product: Object,
        event: Object,
    }

}
</script>

<style scoped>

</style>
